<div class="apply-wrapper">
  <div class="owd-biz-graycontents:40">
    <div>
      <p class="owd-heading:02 spacing:bottom:24">利用時の遵守事項</p>
      <p class="owd-caption">法人インターネットバンキングを安全に利用するため、以下の事項を遵守してください。</p>
    </div>
    <div>
      <p class="owd-heading:01 spacing:bottom:24">認証情報とパスキー端末の管理等</p>
      <ul class="owd-list owd-list:unordered spacing:bottom:24">
        <li>「認証情報」（利用者ID、ログインパスワード、生体認証情報、PIN、パスコード等、Apple ID、Googleアカウント等のプラットフォームアカウントの認証情報）およびパスキーを作成した「パスキー端末」は、利用者の本人確認に使用する重要な情報および機器です。</li>
        <li>利用者は、自己の責任において厳重に管理し、第三者に利用させ、または貸与、譲渡、売買等をしてはなりません。また、紛失・盗難に遭わないよう十分注意してください。</li>
        <li>当行が電話やメールで認証情報を尋ねることはありません。</li>
      </ul>
    </div>

    <div>
      <p class="owd-heading:01 spacing:bottom:24">使用端末の管理</p>
      <ul class="owd-list owd-list:unordered spacing:bottom:24">
        <li>「使用端末」（本サービスの操作を行う「パソコン」や「パスキー端末」）にインストールするOS、ウェブブラウザ等および各種ソフトウェアは最新の状態へ更新してください。</li>
        <li>セキュリティ対策ソフトを導入のうえ、最新の状態へ更新して稼動させてください。</li>
        <li>第三者による不正使用を防ぐため、「使用端末」には必ず「画面ロック」を設定してください。解除には推測されにくいPINやパスコード、または生体認証を使用してください。</li>
      </ul>
    </div>
    <div>
      <p class="owd-heading:01 spacing:bottom:24">取引の確認</p>
      <ul class="owd-list owd-list:unordered spacing:bottom:24">
        <li>不審なログイン履歴や、身に覚えのない取引履歴がないか、頻繁に預金取引明細を確認してください。</li>
        <li>取引発生時や設定変更時に当行から送信する電子メールは、必ず内容を確認してください。</li>
      </ul>
      <ul class="owd-list owd-list:annotation">
        <li>詳細は、「法人インターネットバンキング利用規定」の各条項を確認のうえ、適切な対応をお願いします。</li>
      </ul>
    </div>

    <div>
      <p class="owd-heading:01 spacing:bottom:24">法人インターネットバンキングの推奨環境</p>
      <p class="owd-caption spacing:bottom:16">使用される端末が対応しているか確認してください。</p>
      <div class="owd-table owd-table:full spacing:bottom:24">
        <table>
          <thead>
            <tr>
              <th class="owd-cv:tertiary" style="width: calc((379/1040)*100%);"><strong>対象</strong></th>
              <th class="owd-cv:tertiary"><strong>OSバージョン / 設定</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="owd-cv:tertiary"><strong>Windows PC</strong></th>
              <td>Windows 11 24H2（Windows Hello の設定が必要）</td>
            </tr>
            <tr>
              <th class="owd-cv:tertiary"><strong>Mac</strong></th>
              <td>macOS Sonoma 14.0 以降</td>
            </tr>
            <tr>
              <th class="owd-cv:tertiary"><strong>ブラウザ</strong></th>
              <td>Safari, Chrome, Microsoft Edge の最新版</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul class="owd-list owd-list:annotation">
        <li>法人インターネットバンキングは、パソコンのブラウザで利用してください。スマートフォンのブラウザでは正しく動作しない可能性があります。</li>
      </ul>
    </div>
    <div>
      <p class="owd-heading:01 spacing:bottom:24">口座開設申込に関する注意事項</p>
      <p class="owd-caption spacing:bottom:24">申込み前にご確認ください。</p>
      <ul class="owd-list owd-list:unordered spacing:bottom:24">
        <li>口座開設の申込みは、株式会社NTTデータが提供する「法人口座開設サービス」にて受付を行います。「法人口座開設サービス」のアカウント登録後、ログインのうえ手続きを行ってください。</li>
        <li>審査結果のご案内は、受付後、数日から１週間程度お時間いただく場合があります。</li>
        <li>受付後の審査手続きに関するご案内は、「法人口座開設サービス」内の通知または、登録メールアドレスへ送信いたします。</li>
        <li>申込み内容に不備がある場合は、申込システム内でご案内いたします。システム内の通知およびメールのご案内を必ずご確認ください。</li>
        <li>申込み後、一定期間経過してもお手続き完了とならない場合は、口座開設の申込みを取り下げさせていただきます。</li>
        <li>審査情報や審査結果に関するお問合せには対応いたしかねますので、予めご了承ください。</li>
      </ul>
    </div>
  </div>

  <div class="apply-section">
    <div class="owd-checkbox">
      <div class="owd-checkbox-item owd-checkbox-item:center owd-checkbox-item:large">
        <input type="checkbox" id="modern-check-ex" name="check-modern-ex" value="1">
        <label for="modern-check-ex">
          <p class="owd-text:02"><strong>確認しました</strong></p>
        </label>
      </div>
      <div class="owd-checkbox-effect">
        <div class="owd-checkbox-effect:button">
          <button-biz url="https://businessaccount.minna-no-ginko.com/corporation-account/enterprise_id/00000009/biz_class/1/cacc" id="pc-apply-cv-business" blank title="法人口座を開設する"></button-biz>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
@use "sass:map";
// @use "../global" as g;
.apply{
  &-section{
    display: grid;
    gap: 40px;
    max-width: 294px;
    margin: 64px auto 0;
  }
  @include g.mobile () {
  &-wrapper{
    .owd-heading\:02{
      @include g.owd-typography($fz: 'heading-3', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
      padding: 2px 0;
    }
    .owd-list{
      li{
        @include g.owd-typography($fz: 'caption', $line-height-px: 20, $letter-spacing-tracking: 50, $font-weight: var(--base-normal-weight));
      }
    }
  }
  &-section{
    margin: 16px auto 0;
  }
  }
}
</style>
